var Backbone, SupportDropDownModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportDropDownModel = (function(superClass) {
  extend(SupportDropDownModel, superClass);

  function SupportDropDownModel() {
    return SupportDropDownModel.__super__.constructor.apply(this, arguments);
  }

  SupportDropDownModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=dropdowns&type=dropdowns&should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return SupportDropDownModel;

})(Backbone.Model);

module.exports = SupportDropDownModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvbW9kZWxzL2Ryb3Bkb3ducy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9tb2RlbHMvZHJvcGRvd25zLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLDhCQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFFTDs7Ozs7OztpQ0FDSixVQUFBLEdBQVksU0FBQTtXQUNWLElBQUMsQ0FBQSxHQUFELEdBQVUsTUFBTSxDQUFDLGNBQVIsR0FBdUIsaUVBQXZCLEdBQXdGLFdBQVcsQ0FBQztFQURuRzs7OztHQURxQixRQUFRLENBQUM7O0FBSTVDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
